// Type: Service


import API from "../../helpers/network/http";
import {Rehearsal} from "../../utils/types";

export default class RehearsalService {
    // Create a method to create a rehearsal
    static async addToRehearsal(song_id: string) {
        // Prepare the request body
        const payload = {
            song_id
        }
        // Call the register endpoint from the API
        const {data} = await API.post("/rehearsals", payload);

        // Return the response
        return data;
    }

    // Method to get a user's rehearsals
    static async getRehearsals(): Promise<Rehearsal[]> {
        // Call the login endpoint from the API
        const {data} = await API.get("/rehearsals");

        // Return the response
        return data.data;
    }

    // Method to get a user's practises
    static async getPersonalPractise(song_id: string) {
        // Call the login endpoint from the API
        const {data} = await API.get(`/personal-practise/${song_id}`);

        // Return the response
        return data.data;
    }

}

